<template>
    <div class="notice-audit">
        <!-- 页面标题 -->
        <div class="page-header">
            <h2 class="page-title">中标/招标结果通知审核</h2>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">公告名称:</label>
                <el-input v-model="searchForm.announcementName" placeholder="请输入公告名称" class="search-input" clearable />
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="announcementName" label="公告名称" show-overflow-tooltip />
                <el-table-column prop="announcementNature" label="标段名称" align="center" />
                <el-table-column prop="announcementType" label="中标价格(元)" align="center" />
                <el-table-column prop="createTime" label="发布时间" align="center" />
                <el-table-column prop="status" label="状态" align="center" />
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleViewStatus(scope.row)" class="action-btn">
                            查看状态
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>
    </div>

</template>

<script>
export default {

    data() {
        return {
            loading: false,
            searchForm: {
                announcementName: ''
            },
            tableData: [

            ],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 2
            }
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        // 加载数据
        loadData() {
            this.loading = true
            // 模拟数据加载
            setTimeout(() => {
                this.loading = false
            }, 500)
        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 查看详情
        handleViewDetails(row) {
            this.$message.info(`查看详情: ${row.announcementName}`)
        },

        // 查看状态
        handleViewStatus(row) {
            this.$message.info(`查看状态: ${row.announcementName}`)
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(notice-audit);

.page-header {
    .warning-text {
        margin-left: 10px;
        color: #F56C6C;
        font-size: 14px;
        font-weight: 500;
    }
}
</style>
